import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useSiteContent } from "@/lib/useSiteContent";

const KEY = "hm_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState(false);
  const [prefs, setPrefs] = useState({ necessary: true, statistics: false, marketing: false, external: false });
  const site = useSiteContent();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const save = (mode) => {
    let value = prefs;
    if (mode === "all") value = { necessary: true, statistics: true, marketing: true, external: true };
    if (mode === "essential") value = { necessary: true, statistics: false, marketing: false, external: false };
    localStorage.setItem(KEY, JSON.stringify({ ...value, savedAt: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;
  const categories = Array.isArray(site.cookie_categories) ? site.cookie_categories : [];

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-title"
      className="fixed bottom-3 left-3 right-3 md:left-6 md:right-6 z-50"
      data-testid="cookie-banner"
    >
      <div className="mx-auto max-w-4xl card-soft p-5 md:p-6 relative">
        <button
          className="absolute top-3 right-3 h-8 w-8 rounded-full hover:bg-white/[0.06] grid place-items-center"
          onClick={() => save("essential")}
          aria-label="Schließen"
          data-testid="cookie-close"
        >
          <X size={16}/>
        </button>
        <div id="cookie-title" className="font-display text-lg font-semibold">{site.cookie_title}</div>
        <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
          {site.cookie_text}
        </p>

        {detail && (
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {categories.map((cat) => {
              const forced = cat.key === "necessary";
              return (
                <label key={cat.key} className="flex items-start gap-3 p-3 rounded-lg border border-white/8">
                  <input
                    type="checkbox"
                    className="mt-1 h-4 w-4 accent-[#0055FF]"
                    checked={forced ? true : !!prefs[cat.key]}
                    disabled={forced}
                    onChange={(e) => setPrefs({ ...prefs, [cat.key]: e.target.checked })}
                    data-testid={`cookie-${cat.key}`}
                  />
                  <span>
                    <span className="block text-sm font-medium">{cat.label}</span>
                    <span className="block text-xs text-zinc-500">{cat.desc}</span>
                  </span>
                </label>
              );
            })}
          </div>
        )}

        <div className="mt-5 flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
          <button className="btn-primary" onClick={() => save("all")} data-testid="cookie-accept-all">{site.cookie_accept_all}</button>
          <button className="btn-ghost" onClick={() => save("essential")} data-testid="cookie-essential">{site.cookie_only_essential}</button>
          <button
            className="text-sm text-zinc-400 hover:text-white px-3"
            onClick={() => setDetail(!detail)}
            data-testid="cookie-settings"
          >
            {detail ? site.cookie_less : site.cookie_settings}
          </button>
          {detail && (
            <button className="btn-ghost sm:ml-auto" onClick={() => save("custom")} data-testid="cookie-save-custom">
              {site.cookie_save}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
